import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="CTO Service">
                <h1>Digital Strategy Consultant</h1>
              </div>
              <p className="main_para">
                Digital services that drive your business growth
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_content_txt">
              <p>
                Our digital strategy consulting service are user-centric
                digitalized concepts that deliver unrivaled technology-enabled
                transformation for ultimate experiences.
              </p>
              <ul>
                <li>Business Needs Identification</li>
                <li>Platform-Specific Objectives</li>
                <li>Clients &amp; Social Engagement</li>
                <li>Experience-Led Innovation</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
